import type {
  SearchFeedsRequest,
  SearchFeedsResponse,
  SearchMessageResponse,
  SearchMessagesRequest,
} from "../web-client/api/data-contracts";
import * as operations from "../web-client/api/operations";
import type { Transport } from "../web-client/transport";
import { ApiError } from "../web-client/transport";

/** The `code` a search route answers with, alongside `503`, when its environment has no search index. */
export const SEARCH_UNAVAILABLE = "search_unavailable";

/**
 * Whether a search failed because its environment has no search index, which no retry will fix.
 */
export function isSearchUnavailable(error: unknown): boolean {
  return error instanceof ApiError && error.status === 503 && error.code === SEARCH_UNAVAILABLE;
}

export const searchKeys = {
  messages: (workspaceId: string, request: SearchMessagesRequest) =>
    ["search", "messages", workspaceId, request] as const,
  channels: (workspaceId: string, request: SearchFeedsRequest) => ["search", "channels", workspaceId, request] as const,
};

export function searchMessages(
  transport: Transport,
  { workspaceId, ...body }: { workspaceId: string } & SearchMessagesRequest,
): Promise<SearchMessageResponse> {
  return operations.postSearchMessages(transport, { workspaceId, body });
}

export function searchChannels(
  transport: Transport,
  { workspaceId, ...body }: { workspaceId: string } & SearchFeedsRequest,
): Promise<SearchFeedsResponse> {
  return operations.postSearchFeeds(transport, { workspaceId, body });
}
